<template>
  <div>
    <ul
      :id="'multicheckbox_' + computedId"
      class="vs-ul"
    >
      <template v-for="(checkbox, index) in checkboxForm">
        <li
          :key="'parent_li_' + index"
          class="vs-li"
        >
          <CheckboxInput
            :id="checkbox.id"
            ref="parentCheckboxGroup"
            :key="'parent_checkbox_' + index"
            v-model="checkbox.isSelected"
            :value="checkbox.isSelected"
            :indeterminate="checkbox.indeterminate"
            :label="checkbox.name"
            level="1"
            @onChange="onchange_checkbox"
          />
        </li>
        <li
          v-if="checkbox.childCheckboxes"
          :key="'child_ul_' + index"
          class="vs-li"
        >
          <ul class="vs-ul">
            <template
              v-for="(childCheckbox, childIndex) in checkbox.childCheckboxes"
            >
              <li
                :key="'child_li_' + childIndex"
                class="vs-li"
              >
                <CheckboxInput
                  :id="childCheckbox.id"
                  ref="childCheckboxGroup"
                  :key="'child_checkbox_' + childIndex"
                  v-model="childCheckbox.isSelected"
                  :value="childCheckbox.isSelected"
                  :label="childCheckbox.name"
                  level="2"
                  @onChange="onchange_checkbox"
                />
              </li>
            </template>
          </ul>
        </li>
      </template>
    </ul>
    <button
      v-if="canExpand"
      class="vs-btn vs-link-cta"
      @click="onclick_expand()"
    >
      {{ expandButtonText }}
      <span
        aria-hidden="true"
        class="vs-link-plus-icon"
      >+</span>
    </button>
  </div>
</template>

<script>
import CheckboxInput from '@/components/forms/checkbox/checkboxInput/CheckboxInput.vue';
import { generateId } from '@/helpers/generate-id';

export default {
  name: 'VsMultiCheckbox',
  components: {
    CheckboxInput,
  },
  props: {
    id: { type: String, default: '' },
    content: { type: String, default: null },
    payload: { type: String, default: null },
    expandButtonText: { type: String, default: '' },
  },
  data() {
    return {
      checkboxForm: JSON.parse(this.content),
      canExpand: false,
      computedId: '',
      collapsedBoxes: 5,
    };
  },
  mounted() {
    this.computedId = this.id.length ? this.id : generateId().toString();
    if (this.expandButtonText) {
      this.setCanExpand(true);
    }
    this.oninit();
    if (this.canExpand) {
      this.checkboxForm = this.checkboxForm.splice(0, this.collapsedBoxes);
    }
    this.$forceUpdate();
  },
  methods: {
    oninit() {
      for (let i = 0; i < this.checkboxForm.length; i++) {
        this.setIndeterminateState(this.checkboxForm[i]);
        if (
          i >= this.collapsedBoxes &&
          (this.checkboxForm[i].isSelected ||
            this.checkboxForm[i].indeterminate)
        ) {
          this.setCanExpand(false);
        }
      }
    },
    setCanExpand(canExpand) {
      if (this.checkboxForm.length > this.collapsedBoxes) {
        this.canExpand = canExpand;
      } else {
        this.canExpand = false;
      }
    },
    onclick_expand() {
      const expandedCheckboxForm = JSON.parse(this.content);
      const checkboxFormLength = this.checkboxForm.length;

      for (let i = 0; i < checkboxFormLength; i++) {
        expandedCheckboxForm[i] = this.checkboxForm[i];
      }
      this.checkboxForm = expandedCheckboxForm;
      this.canExpand = false;

      this.$nextTick(() => {
        let checkboxGroup =
          this.$refs.parentCheckboxGroup[checkboxFormLength].$el;
        let input = checkboxGroup.getElementsByTagName('input')[0];

        input.focus();
      });

      this.oninit();
      this.$forceUpdate();
    },
    onchange_checkbox(val) {
      let lvl = val.level;

      if (lvl === 1) {
        let checkbox = this.checkboxForm.find((x) => x.id === val.id);
        checkbox.indeterminate = false;
        if (checkbox.childCheckboxes && checkbox.childCheckboxes.length) {
          checkbox.childCheckboxes.forEach((element) => {
            element.isSelected = val.checked;
          });
        }
      } else if (lvl === 2) {
        let checkbox = this.checkboxForm.find((checkbox) => {
          return (
            checkbox.childCheckboxes &&
            checkbox.childCheckboxes.length &&
            checkbox.childCheckboxes.find(
              (childCheckbox) => childCheckbox.id === val.id
            ) !== undefined
          );
        });
        this.setIndeterminateState(checkbox);
        this.$forceUpdate();
      }

      this.$emit('change_multicheckbox', {
        checkbox: val,
        payload: JSON.parse(this.payload),
      });
    },
    setIndeterminateState(checkbox) {
      let numChecked = 0;
      if (checkbox.childCheckboxes && checkbox.childCheckboxes.length) {
        checkbox.childCheckboxes.forEach((element) => {
          if (element.isSelected) {
            numChecked++;
          }
        });
        checkbox.indeterminate =
          numChecked > 0 && numChecked < checkbox.childCheckboxes.length;
        if (!checkbox.indeterminate) {
          checkbox.isSelected = numChecked === checkbox.childCheckboxes.length;
        }
      }
    },
    resetValues(content) {
      if (!this.canExpand) {
        this.setCanExpand(true);
      }
      if (content && content.length) {
        this.checkboxForm = JSON.parse(content);
        this.oninit();
      } else {
        this.checkboxForm.forEach((checkbox) => {
          checkbox.isSelected = false;
          if (checkbox.childCheckboxes && checkbox.childCheckboxes.length) {
            checkbox.childCheckboxes.forEach((childCheckbox) => {
              childCheckbox.isSelected = false;
            });
          }
        });
      }
      if (this.canExpand) {
        this.checkboxForm = this.checkboxForm.splice(0, this.collapsedBoxes);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/buttons/buttons';
@import '@/styles/links/erclinks';
@import '@/styles/utilities';
</style>
